export default __webpack_public_path__ + "static/media/capture-img.e59b1b16.png";